export var TOP_BANNER = 'top-banner';
export var TOP_BANNER_BREADCRUMBS = 'top-banner-breadcrumbs';
export var TOP_BANNER_IMAGE = 'top-banner-image';
export var TOP_BANNER_TITLE = 'top-banner-title';
export var TOP_BANNER_MOBILE_HEIGHT = 180;
export var TOP_BANNER_DESKTOP_HEIGHT = 280;
//# sourceMappingURL=constants.js.map